import { useEffect, useState } from 'react';
import axios from 'axios';
import { getCookie, setCookie } from '../utils/cookieUtils';
import { logger } from '../utils/logger';

const useUserLocation = () => {
    const [location, setLocation] = useState(null);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const lat = getCookie('user_lat');
        const lng = getCookie('user_lng');

        if (lat && lng) {
            const latNum = parseFloat(lat);
            const lngNum = parseFloat(lng);
            if (!isNaN(latNum) && !isNaN(lngNum)) {
                setLocation({ lat: latNum, lng: lngNum });
            }
            setReady(true);
            return;
        }

        setReady(true);

        const fetchIpLocation = async () => {
            try {
                const res = await axios.get('https://ipapi.co/json/');
                const { latitude, longitude } = res.data;
                if (latitude && longitude) {
                    setCookie('user_lat', latitude, 30);
                    setCookie('user_lng', longitude, 30);
                    setLocation({ lat: latitude, lng: longitude });
                }
            } catch (error) {
                logger.warn('Failed to fetch IP location', error);
            }
        };

        let cancelTask;
        if ('requestIdleCallback' in window) {
            const idleId = window.requestIdleCallback(fetchIpLocation, { timeout: 2500 });
            cancelTask = () => window.cancelIdleCallback(idleId);
        } else {
            const timeoutId = setTimeout(fetchIpLocation, 400);
            cancelTask = () => clearTimeout(timeoutId);
        }

        return () => cancelTask?.();
    }, []);

    return { location, ready };
};

export default useUserLocation;
